import React from "react";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

export const TOLL_FREE_TEXT_CLASS = "text-sky-600 dark:text-sky-400";

export function TollFreeBadge({ className }: { className?: string }) {
  return (
    <Badge
      variant="outline"
      className={cn("border-sky-300 bg-sky-50 text-sky-700 dark:border-sky-800 dark:bg-sky-950 dark:text-sky-300", className)}
    >
      Toll-free
    </Badge>
  );
}
